import React, { FunctionComponent, useState } from "react";
import { debounce } from "utils/debounce";
import { useFormikContext } from "formik";

export interface Props {
  name: string;
}
const createSaveFormValuesDebounced = (name: string) =>
  debounce((values: unknown) => {
    sessionStorage.setItem(name, JSON.stringify(values));
  }, 300);

const loadFormValues = (name: string) => {
  const item = sessionStorage.getItem(name);
  if (item) {
    try {
      return JSON.parse(item);
    } catch (e) {
      console.error(e);
    }
  }
};

export const FormikPersist: FunctionComponent<Props> = ({ children, name }) => {
  const [loading, setLoading] = useState(true);
  const { values, setValues } = useFormikContext();

  const saveDebounced = React.useMemo(() => createSaveFormValuesDebounced(name), [name]);

  React.useEffect(() => {
    const loadedFormValues = loadFormValues(name);
    if (loadedFormValues) {
      setValues(loadedFormValues);
    }
    setLoading(false);
  }, [name, setValues]);

  React.useEffect(() => {
    if (values) {
      saveDebounced(values);
    }
  }, [saveDebounced, values]);

  if (loading) {
    return null;
  }

  return <>{children}</>;
};

FormikPersist.displayName = "FormikPersist";
